import React, { useEffect } from 'react';
import { Container, Row, Col, Navbar, Nav, Button, Card, Badge, ListGroup } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import './PressOnly.css'; // Custom styles
import AOS from "aos";

import "aos/dist/aos.css";
import { useNavigate } from 'react-router-dom';
const mainservis = "/images/main.jpg";

const pressImg =
  "/sabmenu/servicesArtboard-1-copy-11.webp";

const pressImg11 =
  "/sabmenu/1718881711.png";


const pressImg1122 =
  "/sabmenu/shutterstock_424728877-scaled.jpg";


const PressOnlyBootstrap = () => {
  const navigate = useNavigate();

  useEffect(() => {
    AOS.init({
      duration: 1200,
      easing: "ease-in-out",
      once: true,
      offset: 80,
    });
  }, []);
  const benefits = [
    { title: "Sharper & crisper finish", desc: "Look professional and well-groomed every day.", icon: "📏" },
    { title: "Kills bacteria and germs at 150 °C", desc: "Safer for children, sensitive skin and health.", icon: "🧪" },
    { title: "Odour elimination", desc: "Genuine freshness, not just a clean smell.", icon: "💨" },
    { title: "Safe Care for Delicates", desc: "Peace of mind for your most valued garments", icon: "👗" },
    { title: "Longer-lasting garments", desc: "Save money — clothes stay new for longer", icon: "⌛" }
  ];

  const precisionOccasions = [
    { name: "Dress Shirts", icon: "👔" },
    { name: "Trousers", icon: "👖" },
    { name: "Suit Jackets", icon: "🧥" },
    { name: "Kandora", icon: "🕌" },
    { name: "Abaya", icon: "🧕" },
    { name: "Sheila", icon: "🧣" },
    { name: "School Uniforms", icon: "🎓" },
    { name: "Formal Wear", icon: "✨" }
  ];

  return (
    <div className="press-only-app mt-2">
      <section className="hero-section-pressonly-clean  pt-5 mt-5 position-relative overflow-hidden">
        <div className="hero-overlay-freash-clean py-3">
          <Container fluid="xl" className="py-3 mt-4 h-100">
            <Row className="align-items-center justify-content-center text-center h-100">
              <Col lg={8}>
                <h1 className="hero-title mb-4">
                  Press Only Finish Sharp Lines. Effortless Elegance <br />

                </h1>
                <p style={{ color: "white", textAlign: "center", fontSize: "20px" }}>Because a well-pressed garment speaks before you do.

                </p>
                <div className="d-flex justify-content-center flex-wrap gap-3 mt-4">
                  <button className="hero-btn-dark"
                    onClick={() =>
                      window.open(
                        "https://api.whatsapp.com/send?phone=971545718455&text=Hi,%20I%20would%20like%20to%20book%20a%20laundry%20pickup.",
                        "_blank"
                      )
                    }
                    style={{ backgroundColor: "rgb(25 135 29)" }}>
                    BOON NOW
                  </button>

                  <button className="view-prices-list"
                    onClick={() => navigate("/laundry-price")}
                  >
                    VIEW PRICE LIST
                  </button>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </section>
      {/* Navigation */}

      <section className="py-5 bg-white">
        <Container fluid="xl" className="py-5">
          <h2 className="expertise-title">The Distinction is in the Detail</h2>
          <Row className="g-4 mt-5">
            {benefits.map((benefit, idx) => (
              <Col key={idx} md={idx === 1 ? 4 : 4} lg={idx < 2 ? 6 : 4}>
                <Card className={`h-100 border-0 p-3 rounded-0 transition-hover ${idx === 1 ? 'bg-primary-dark text-white' : 'bg-light'}`} style={{ boxShadow: "0px 0px 1px 1px #0640b3", borderRadius: "5px" }}>
                  <Card.Body>
                    <div className="fs-2 mb-3">{benefit.icon}</div>
                    <h4 className="fw-bold mb-3">{benefit.title}</h4>
                    <Card.Text className={idx === 1 ? 'text-white-50' : 'text-muted'}>{benefit.desc}</Card.Text>
                    {idx === 0 && <span className="text-uppercase x-small tracking-widest fw-bold mt-4 d-block opacity-50">Signature Precision</span>}
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>


      <section className="pressonly-wrap" data-aos="zoom-in-right">
        <div className="pressonly-container mt-5">
          {/* LEFT IMAGE */}
          <div className="pressonly-image">
            <img src={pressImg} alt="Press Only" />
          </div>

          {/* RIGHT CONTENT */}
          <div className="pressonly-content" data-aos="fade-down">
            <h2 className='expertise-title'>Press Only</h2>

            <p>
              First impressions live in the details — the crisp edge of a collar, the clean fall of a sleeve, the perfectly placed crease of a trouser. Our Press Only service is built for garments that are clean but need to look their absolute best. Using professional-grade steam pressing equipment calibrated to each fabric type, we deliver a finish that home irons simply cannot replicate.
            </p>

            <div className="pressonly-buttons">
              <button className="btn-book"
                onClick={() =>
                  window.open(
                    "https://api.whatsapp.com/send?phone=971545718455&text=Hi,%20I%20would%20like%20to%20book%20a%20laundry%20pickup.",
                    "_blank"
                  )
                }>Book Now</button>
              <button className="btn-price"
                onClick={() => navigate("/laundry-price")}
              >Pricing</button>
            </div>
          </div>
        </div>
      </section>

      {/* Distinction Section */}


      {/* The Cultural Anchor - Kandora */}
      <section className="py-5 bg-light-gray">
        <Container fluid="xl" className="py-5">
          <Row className="align-items-center g-5">

            <Col lg={6}>
              <span className="text-uppercase tracking-widest text-primary-main x-small fw-bold mb-3 d-block">The Cultural Anchor</span>
              <h2 className="expertise-title">Brightness restoration for Kandoras</h2>
              <p className="text-muted fs-5 lh-lg mb-4">
                Our specialized pressing restores the luminous white finish of your Kandoras, ensuring every line is architectural and every fold is intentional.
              </p>
              <ul className="list-unstyled space-y-3">
                <li className="d-flex align-items-center gap-2 mb-2">
                  <span className="text-primary-main">✓</span>
                  <span className="small fw-bold text-uppercase">Zero-shine finish technology</span>
                </li>
                <li className="d-flex align-items-center gap-2">
                  <span className="text-primary-main">✓</span>
                  <span className="small fw-bold text-uppercase text-justify">Collar and cuff reinforcement</span>
                </li>
              </ul>
            </Col>
            <Col lg={6} className="text-center">
              <img src={pressImg11} alt="Pristine Kandora" className="img-fluid shadow-lg rounded-2" style={{ maxHeight: '450px' }} />
            </Col>

          </Row>
        </Container>
      </section>

      {/* The Delicate Balance - Abaya */}
      <section className="py-5 bg-white">
        <Container fluid="xl" className="py-5">
          <Row className="align-items-center g-5 flex-lg-row-reverse">

            <Col lg={6}>
              <span className="text-uppercase tracking-widest text-primary-main x-small fw-bold mb-3 d-block">The Delicate Balance</span>
              <h2 className="expertise-title">Protection for delicate Abayas and silks</h2>
              <p className="text-muted fs-5 lh-lg mb-4">
                High-fashion fabrics require more than just heat; they require airflow and humidity control. We treat your silks and delicate overlays with archival care.
              </p>
              <div className="border-start border-primary-main border-4 ps-4 py-2 bg-light">
                <p className="fst-italic text-muted mb-0">"The difference between a garment that looks 'done' and one that looks 'curated' is the quality of the press."</p>
              </div>
            </Col>

            <Col lg={6} className="text-center">
              <img src={pressImg1122} alt="Embellished Abaya" className="img-fluid shadow-lg rounded-2" style={{ maxHeight: '550px' }} />
            </Col>
          </Row>
        </Container>
      </section>

      <section id="services" className="py-5 bg-light">
        <Container fluid="xl" className="py-5 text-center">
          <h2 className="display-6 fw-bold mb-2">Key Benefits</h2>
          <p style={{ fontSize: "20px" }} className="expertise-title">Excellence in every fiber</p>
          <Row className="g-4 py-4">
            {[
              { title: "Press Only. Perfect Always.", desc: "Premium Steam finishing — the standard your wardrobe deserves.", dark: true },
              { title: "Your Clothes Look Sharper — Instantly", desc: "Industrial steam penetrates deep into every fibre, not just the surface. The result is a level of crispness — sharp collar edges, clean trouser creases, perfectly flat sleeves. ." },
              { title: "Your Kandora Stays Whiter and Brighter", desc: "The combination of high-pressure steam and professional-grade finishing restores the brightness and whiteness of cotton and polyester Kandoras that dull over time. ", highlighted: true },
              { title: "Your Clothes Last Significantly Longer", desc: "No direct heat, protecting fabrics from shine and damage. Our professional pressing regularly finds garments hold their shape and colour for longer", highlighted: true },
              { title: "Delicate Fabrics Are Completely Safe", desc: "Your Abaya embroidery, silk blouse, chiffon evening gown, or beaded Jalabiya is handled without direct iron contact. Steam is applied from a controlled distance, protecting every bead, sequin, and stitch. There is no risk of burns, shine patches, or fabric distortion.", dark: true },
              { title: "Bacteria and Allergens Are Eliminated", desc: "Industrial steam reaches temperatures that kill bacteria, dust mites, and odour-causing microbes deep inside fabric fibres — far beyond what a washing machine alone achieves. " },
              { title: "Stubborn Odours Are Gone — Not Masked", desc: "Perfume, smoke, sweat, and food odours trapped in fabric fibres are neutralised by steam at the molecular level. Unlike sprays or fabric fresheners that sit on the surface, steam eliminates the source. Your garment smells naturally clean.", },
              { title: "The Finish Actually Stays", desc: "Steam resets fabric fibres deeply, so the pressed finish holds for much longer than home ironing. A shirt pressed at home may wrinkle within hours of wearing. A shirt finished on an industrial steam press keeps its shape through a full day — or longer." },
              { title: "Special Occasion Garments Are Ready When You Are", desc: "Wedding outfits, Eid thobes, formal suits, and embellished Abayas stored between seasons can arrive creased, musty, or misshapen. A single professional steam press session restores them completely — no re-washing needed. Ready to wear with confidenceConsistent Quality — Every Single Order", dark: true },


            ].map((benefit, idx) => (
              <Col key={idx} md={idx === 6 ? 12 : 6} lg={idx === 6 ? 4 : 4}>
                <Card className={`h-100 border-0 shadow-sm py-4 rounded-3 text-start transition-hover ${benefit.highlighted ? 'bg-primary-tint' : benefit.dark ? 'bg-primary-dark text-white' : 'bg-white'}`}>
                  <Card.Body>
                    <h4 className="fw-bold mb-3">{benefit.title}</h4>
                    <Card.Text className={benefit.dark ? 'text-white-50' : 'text-muted'}>{benefit.desc}</Card.Text>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* Precision for Occasion Grid */}
      <section className="py-5 bg-primary-white text-dark text-center">
        <Container fluid="xl" className="py-5">
          <h2 className="expertise-title">Precision for Every Occasion</h2>
          <p className="text-black-50 mb-5" style={{ color: "black" }}>From daily boardroom attire to heritage ceremonial wear, our specialists understand the geometry of your wardrobe.</p>
          <Row className="g-3">
            {precisionOccasions.map((occ, idx) => (
              <Col key={idx} xs={6} md={3}>
                <div className="p-4 bg-primary bg-opacity-10 rounded-1 hover-scale transition-all">
                  <div className="fs-3 mb-2">{occ.icon}</div>
                  <span className="text-uppercase x-small tracking-widest fw-bold">{occ.name}</span>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>
      <Container fluid="xl" className="py-5">
        <Row>
          <Col lg={12}>

            <h2 className='expertise-title'>
              Special Occasion Garments <br /> Are Ready When You Are</h2>
            {/* <p className="sub-title">Our Expert Dry Clean Services</p> */}
            <p className="desc">
              Wedding outfits, Eid thobes, formal suits, and embellished Abayas stored between seasons can arrive creased, musty, or misshapen. A single professional steam press session restores them completely — no re-washing needed. Ready to wear with confidence.
              Consistent Quality — Every Single Order

              Our pressing machines are calibrated to exact temperature and pressure settings per fabric type, every order delivers the same flawless result. No guesswork, no variation, no days when the iron was too hot. Your garments are treated the same way by a machine that has been set by an expert — every time.

            </p>
          </Col>
        </Row>
      </Container>




      {/* CTA Banner */}
      <section className="py-2 bg-light">
        <Container fluid="xl" className="my-5">
          <div className="cta-banner-dark bg-primary-dark rounded-4 p-5 text-center text-white position-relative overflow-hidden">
            <div className="position-relative z-1">
              <h2 className="display-3 fw-bold mb-4 text-center">Ready to Elevate Your Look?</h2>
              <p className="text-white-50 mb-5 fs-5">Book your press only service via our dedicated mobile application or directly through WhatsApp for immediate pickup.</p>
              <div className="d-flex flex-column flex-md-row justify-content-center gap-4">
                <Button variant="light" size="lg" className="px-5 py-3 fw-bold text-primary-dark d-flex align-items-center justify-content-center gap-2">
                  <span>📱</span> DOWNLOAD APP
                </Button>
                <Button
                  onClick={() =>
    window.open(
      "https://api.whatsapp.com/send?phone=971545718455&text=Hi,%20I%20would%20like%20to%20book%20a%20laundry%20pickup.",
      "_blank"
    )
  } variant="success" size="lg" className="px-5 py-3 fw-bold border-0 d-flex align-items-center justify-content-center gap-2" style={{ backgroundColor: '#25D366' }}>
                  <span>💬</span> WHATSAPP NOW
                </Button>
              </div>
            </div>
            <div className="blob blob-1" style={{ top: '-50px', right: '-50px', background: 'rgba(255,255,255,0.05)' }}></div>
          </div>
        </Container>
      </section>




    </div>
  );
};

export default PressOnlyBootstrap;
